<template>
  <div>
    <div class="layer z-40 inset-0	 h-screen w-screen fixed"  @click="closeQualify"></div>
    <div class="fixed z-50  rate_us	 w-fit h-fit bg-white rounded-lg p-40">
      <div class="absolute right-2.5 t8px" @click="closeQualify">
        <Close class="cursor-pointer" />
      </div>

      <p class="mb-12px text-big font-bold roboto">
        ¡Puntua tu experiencia con este curso!
      </p>

      <star-rating
        class="mx-auto w-fit"
        :padding="15"
        :rounded-corners="false"
        :show-rating="false"
        :star-size="25"
      />
    </div>
  </div>
</template>

<script>
import Close from "./icons/Close.vue";
import StarRating from "vue-star-rating";

export default {
  components: {
    Close,
    StarRating,
  },
  methods: {
    closeQualify() {
      this.$store.commit("openqualify", false);
    },
  },
};
</script>

<style scoped>
.rate_us {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.layer {
  background: rgba(0, 0, 0, 0.466);
}
.t8px {
  top: 8px;
}
</style>
